import { alert } from '../../../../base/browser/ui/aria/aria.js';
import { localizeWithPath } from '../../../../nls.js';
import { Disposable } from '../../../../base/common/lifecycle.js';
import { toErrorMessage } from '../../../../base/common/errorMessage.js';
import { NotificationPriority } from '../../../../platform/notification/common/notification.js';
import { Event } from '../../../../base/common/event.js';
import Severity$1 from '../../../../base/common/severity.js';
const _moduleId = "vs/workbench/browser/parts/notifications/notificationsAlerts";
class NotificationsAlerts extends Disposable {
    constructor(model) {
        super();
        this.model = model;
        for (const notification of model.notifications) {
            this.triggerAriaAlert(notification);
        }
        this.registerListeners();
    }
    registerListeners() {
        this._register(this.model.onDidChangeNotification(e => this.onDidChangeNotification(e)));
    }
    onDidChangeNotification(e) {
        if (e.kind === 0 ) {
            this.triggerAriaAlert(e.item);
            if (e.item.severity === Severity$1.Error) {
                if (e.item.message.original instanceof Error) {
                    console.error(e.item.message.original);
                }
                else {
                    console.error(toErrorMessage(( (e.item.message.linkedText.toString())), true));
                }
            }
        }
    }
    triggerAriaAlert(notification) {
        if (notification.priority === NotificationPriority.SILENT) {
            return;
        }
        const listener = notification.onDidChangeContent(e => {
            if (e.kind === 1 ) {
                this.doTriggerAriaAlert(notification);
            }
        });
        Event.once(notification.onDidClose)(() => listener.dispose());
        this.doTriggerAriaAlert(notification);
    }
    doTriggerAriaAlert(notification) {
        let alertText;
        if (notification.severity === Severity$1.Error) {
            alertText = ( localizeWithPath(
                _moduleId,
                0,
                "Error: {0}",
                 (notification.message.linkedText.toString())
            ));
        }
        else if (notification.severity === Severity$1.Warning) {
            alertText = ( localizeWithPath(
                _moduleId,
                1,
                "Warning: {0}",
                 (notification.message.linkedText.toString())
            ));
        }
        else {
            alertText = ( localizeWithPath(
                _moduleId,
                2,
                "Info: {0}",
                 (notification.message.linkedText.toString())
            ));
        }
        alert(alertText);
    }
}
export { NotificationsAlerts };
